export default __webpack_public_path__ + "static/HYPED_Hero_Crystal-Mobile-4f9bd574954aa7b5d53c1fe98b6caa6b.gif";